import { render, staticRenderFns } from "./OptionNetwork.vue?vue&type=template&id=20e88412&scoped=true&"
import script from "./OptionNetwork.vue?vue&type=script&lang=ts&"
export * from "./OptionNetwork.vue?vue&type=script&lang=ts&"
import style0 from "./OptionNetwork.vue?vue&type=style&index=0&id=20e88412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e88412",
  null
  
)

export default component.exports